import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { MODAL_TYPE_SEND_PICKUP_COMPLETE, showModal as showModalAction, } from '../../../actions/ModalActions';
import { API_GET_LIST_SEARCH_SOLUTION, API_GET_LIST_SEARCH_SOLUTION_MORE, apiGetListSearch as apiGetListSearchAction, apiGetListMoreSearch as apiGetListMoreSearchAction, searchViewReplace, searchParamReplace, searchPreKeywordSet, searchParamSet, } from '../../../actions/SearchSolutionActions';
import { isClient } from '../../../helpers/auth';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import { propArrayShape, propBool, propFunc, propShape, PropTypesAuthToken, propLocation, propMatch, propHistory, } from '../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../helpers/fetch';
import { statesToSearch, statesToQuery, queryToStates, } from '../../../helpers/search_query';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import SearchBody from './SearchBody';
import SearchSort from './SearchBody/SearchSort';
import SearchTitle from './SearchBody/SearchTitle';
import SideMenu from './SideMenu';
class Search extends Component {
    constructor(props) {
        super(props);
        this.runQuery = (states = null, query = null) => {
            const { apiGetListSearch, location } = this.props;
            // 最後に検索を行った条件を取得
            const searchQuery = query || location.search;
            // stateから検索パラメータ作成
            const findParams = states || queryToStates(location.search);
            // 検索パラメータをapi向けに変更
            const searchParams = statesToSearch(findParams);
            if (!isNullOrUndefinedOrEmpty(searchParams.price_lte)) {
                searchParams.price_lte *= 10000;
            }
            if (!isNullOrUndefinedOrEmpty(searchParams.price_gte)) {
                searchParams.price_gte *= 10000;
            }
            apiGetListSearch(searchParams, searchQuery);
        };
        this.runMoreQuery = () => {
            const { apiGetListMoreSearch, location, searchSolution } = this.props;
            const page = searchSolution.page || 1;
            // urlから検索パラメータ作成
            const findParams = queryToStates(location.search);
            // 検索パラメータをapi向けに変更して実行
            const searchParams = statesToSearch(findParams);
            apiGetListMoreSearch(searchParams, page + 1);
        };
        this.onClickOrder = (e) => {
            const { setParamMerge } = this.props;
            setParamMerge({ order: e.currentTarget.value });
        };
        this.state = {
            viewItems: [],
        };
    }
    componentDidMount() {
        const { history, location, match, middles, searchSolution, setParam, setPreKeyword, setView, } = this.props;
        // URLのquery stringからstateを復帰させる
        const states = queryToStates(location.search);
        setParam(states);
        // デフォ値まで考慮したURLを取得
        const defaultQuery = statesToQuery(states);
        const newUrl = `${match.url}?${defaultQuery}`;
        history.replace(newUrl);
        // query stringから取得した値にmiddle categoryの値が存在する場合は開く
        const views = {};
        Object.keys(states)
            .filter((str) => str.indexOf('middle_') === 0)
            .forEach((str) => {
            const id = parseInt(str.replace('middle_', ''), 10);
            const { solutionLargeClassId } = middles.find((m) => m.id === id) || {};
            if (solutionLargeClassId) {
                views[`large_${solutionLargeClassId}`] = true;
            }
        });
        // 初期表示項目の設定
        setView(views);
        // URLから表示用検索キーワードを作成する
        setPreKeyword(states.keyword);
        // 最後に実行した検索条件と見比べて、未設定か異なっていればAPIを投げる
        // 投げない場合は最後に実行した結果が表示される
        const { lastQuery } = searchSolution;
        if (!lastQuery || location.search !== lastQuery) {
            // パラメータ生成後に検索を実施
            this.runQuery(states);
        }
    }
    shouldComponentUpdate(nextProps) {
        const { searchSolution } = this.props;
        const { searchSolution: nextSearchSolution } = nextProps;
        const items = searchSolution.list;
        const nextItems = nextSearchSolution.list;
        if (items !== nextItems) {
            const perPage = 5;
            const updateItems = nextItems.length < perPage
                ? [...nextItems, 'pickup']
                : [
                    ...nextItems.slice(0, perPage),
                    'pickup',
                    ...nextItems.slice(perPage),
                ];
            this.setState({
                viewItems: updateItems,
            });
        }
        return true;
    }
    componentDidUpdate() {
        // propsの値からURLを作成する
        const { history, location, match, searchSolution } = this.props;
        const params = Object.assign({}, searchSolution.params);
        const newQuery = statesToQuery(params);
        const currentUrl = `${location.pathname}${location.search}`;
        const newUrl = `${match.url}?${newQuery}`;
        if (currentUrl !== newUrl) {
            history.replace(newUrl);
            this.runQuery(params, newQuery);
        }
    }
    render() {
        const { auth, isLoading, isMoreLoading, profile, searchSolution, showSendPickupCompleteModal, } = this.props;
        const { viewItems } = this.state;
        const isClientLogin = isClient(auth);
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main archives' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u691C\u7D22\uFF5CPROFFIT Mart" }) }), _jsxs("div", Object.assign({ className: 'l-container l-contents' }, { children: [_jsx(SideMenu, { isLogin: isClientLogin }), _jsxs("div", Object.assign({ className: 'l-container-9 load-container' }, { children: [_jsx(SearchTitle, { total: searchSolution.total }), _jsx(SearchSort, { changeSort: this.onClickOrder, currentOrder: searchSolution.params.order || 'popular' }), _jsx(SearchBody, { auth: auth, isLoading: isLoading, isLoadingMarginTop: 42, isMoreLoading: isMoreLoading, profile: profile, runMoreQuery: this.runMoreQuery, searchSolution: searchSolution, showSendPickupCompleteModal: showSendPickupCompleteModal, viewItems: viewItems })] }))] }))] })));
    }
}
Search.propTypes = {
    apiGetListMoreSearch: propFunc().isRequired,
    apiGetListSearch: propFunc().isRequired,
    auth: PropTypesAuthToken.isRequired,
    history: propHistory(),
    isLoading: propBool().isRequired,
    isMoreLoading: propBool().isRequired,
    location: propLocation(),
    match: propMatch(),
    middles: propArrayShape().isRequired,
    profile: propShape(),
    searchSolution: propShape().isRequired,
    setParam: propFunc().isRequired,
    setParamMerge: propFunc().isRequired,
    setPreKeyword: propFunc().isRequired,
    setView: propFunc().isRequired,
    showSendPickupCompleteModal: propFunc().isRequired,
};
Search.defaultProps = {
    profile: {},
};
const mapStateToProps = ({ auth, category, fetch, profile, searchSolution, }) => ({
    auth,
    isLoading: isLoadingApis(fetch, API_GET_LIST_SEARCH_SOLUTION),
    isMoreLoading: isLoadingApis(fetch, API_GET_LIST_SEARCH_SOLUTION_MORE),
    middles: category.solutionMiddleClass,
    profile,
    searchSolution,
});
const mapDispatchToProps = (dispatch) => ({
    apiGetListMoreSearch: (params, page) => {
        dispatch(apiGetListMoreSearchAction(params, page));
    },
    apiGetListSearch: (params, lastQuery) => {
        dispatch(apiGetListSearchAction(params, lastQuery));
    },
    setParam: (payload) => {
        if (Object.keys(payload)) {
            dispatch(searchParamReplace(payload));
        }
    },
    setParamMerge: (payload) => {
        if (Object.keys(payload)) {
            dispatch(searchParamSet(payload));
        }
    },
    setPreKeyword: (payload) => {
        dispatch(searchPreKeywordSet(payload));
    },
    setView: (payload) => {
        if (Object.keys(payload)) {
            dispatch(searchViewReplace(payload));
        }
    },
    showSendPickupCompleteModal: () => dispatch(showModalAction(MODAL_TYPE_SEND_PICKUP_COMPLETE)),
});
const enhance = compose(AuthenticationHoc({
    isCanUseProffitMart: true,
    isMember: true,
}), connect(mapStateToProps, mapDispatchToProps));
export default enhance(Search);
